enum ProjectRunStateEnum {
  Created = 'created',
  Queued = 'queued',
  InProgress = 'in_progress',
  Finished = 'finished',
}

export default ProjectRunStateEnum
